// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gws9","footer":"styles_footer__1SfCy"};